export const SUBSCRIPTION_NAME_MAX_LENGTH = 255;

// Сумма ширин колонок (220 + 100 + 130 + 240 + 150 + 120 + 48) плюс ~8% запаса
export const SUBSCRIPTION_SERVICES_TABLE_SCROLL_X = 1090;
